module.exports = __webpack_public_path__ + "static/media/siebel1.b339587b.png";